import {Component , OnInit} from '@angular/core';

import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'fuse-mail-confirm',
    templateUrl: './mail-confirm.component.html',
    styleUrls: ['./mail-confirm.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class FuseMailConfirmComponent implements OnInit
{
   email = '';

    constructor(
        private fuseConfig: FuseConfigService,
        private route: ActivatedRoute
    )
    {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });
    }

    ngOnInit() {
      this.email = this.route.snapshot.queryParamMap.get('email');
    }
}
